import { createRouter, createWebHistory } from 'vue-router';

const routes = [
   {
      path: '',
      name: 'NewApp',
      component: () => import('@/modules/new-app-available/Index.vue'),
   },
   {
      path: '/:pathMatch(.*)*',
      redirect: '',
   },
];

const router = createRouter({
   history: createWebHistory(import.meta.env.BASE_URL),
   routes,
});

export default router;
